import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import { Toast, Loading } from 'vant';
import tvbUi from '@commonComps/tvb-ui/index.js';
import '@/assets/css/reset.css';

Vue.config.productionTip = false;
window.onWebPageVisiableChange = function(res) {};

Vue.use(Toast);
Vue.use(Loading);
Vue.use(tvbUi);

Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
